
/* @flow */
import React, { PropTypes } from 'react';
import DistributionContainer from './distribution/distribution-container';
import FooterContainer from './footer/footer-container';
import OffersContainer from './offers/offers-container';
import Invoicing from './invoicing';

export class PartTwo extends React.Component {

  static propTypes = {
    postInvoice: PropTypes.func.isRequired,
    openPreviewModal: PropTypes.func.isRequired,
    closePreviewModal: PropTypes.func.isRequired,
    openSendModal: PropTypes.func.isRequired,
    closeSendModal: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,
    registerAssignmentTool: PropTypes.bool.isRequired,
    translationPrefix: PropTypes.string.isRequired
  };

  renderOffersContainer () {
    if (!this.props.registerAssignmentTool) {
      return (
        <div className='section-padding'>
          <div className='col-sm-12'>
            <OffersContainer />
          </div>
        </div>
      );
    }
    return null;
  }

  render () {
    return (
      <div className='tool-wrapper'>
        <div className='tool-content container payment-details-bottom'>
          <div className='section-padding'>
            <div className='col-sm-12'>
              <DistributionContainer
                translationPrefix={this.props.translationPrefix}
              />
            </div>
          </div>
          {this.renderOffersContainer()}
          <div className='col-xs-12'>
            <Invoicing
              translationPrefix={this.props.translationPrefix}
            />
          </div>
          <FooterContainer
            postInvoice={this.props.postInvoice}
            openPreviewModal={this.props.openPreviewModal}
            closePreviewModal={this.props.closePreviewModal}
            openSendModal={this.props.openSendModal}
            closeSendModal={this.props.closeSendModal}
            onClickSave={this.props.onClickSave}
            translationPrefix={this.props.translationPrefix}
            registerAssignmentTool={this.props.registerAssignmentTool}
          />
        </div>
      </div>
    );
  }
}

export default PartTwo;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/invoice-payment-details.js
 **/